export class MetaData {
  metaDataId?: number;
  metaDataMappingId: number;
  value: string;
  studyId?: string;
  visit?: string;
  eye?: string;
  patientId?: string;
  geneticId?: number;
  metabolomicId?: number;
  metaDataMappings: MetaDataMapping[];
}
export class MetaDataMapping {
  metaDataMappingId?: number;
  spreadsheetId: string;
  dataGroupName: string;
  columnId: string;
  columnName: string;
  parameterType: string;
  metaData?: MetaData;
  hideFromSearch?: boolean;
  gradingInputType: string;
  etdrsGroup: string;
  etdrsNumber: number;
  gradingDropdownOptions: string;
  gradingHousekeeping?: boolean;
  gradingRequired?: boolean;
  gradingHide?: boolean;
  autofillLookup: number;
  gradingKnownValue: string;
  validationType?: ValidationTypes;
}

export enum ValidationTypes {
  singleDigit = "singleDigit",
  threeDigits = "threeDigits",
  threeDigitsDecimal = "threeDigitsDecimal",
  threeDigitsDecimalMax10 = "threeDigitsDecimalMax10",
  threeDigitsDecimalMax10orTripleDigits = "threeDigitsDecimalMax10orTripleDigits",
  threeDigitsOr789s = "threeDigitsOr789s",
}

export class MetaDataRaw {
  metaDataId?: number;
  metaDataMappingId: number;
  value: string;
  visit?: string;
  eye?: string;
  patientId?: string;
  geneticId?: number;
  metabolomicId?: number;
  createdAt: string;
  dataGroupName: string;
  columnName: string;
  "metaDataMappings.dataGroupName": string;
  "metaDataMappings.columnName": string;
}



// WEBPACK FOOTER //
// ./src/app/models/meta-data.model.ts